import React, { useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaGamepad } from "react-icons/fa";
import { GiCardboardBoxClosed } from "react-icons/gi";
import { RiNetflixFill } from "react-icons/ri";
import "../styles/modern-category-layout.css";
import { IoIosGift } from "react-icons/io";

const CategoryLayout = ({ title, children }) => {
    const location = useLocation();

    useEffect(() => {
        document.title = title;
    }, [title]);

    return (
        <div className="mcl-layout">
            <aside className="mcl-sidebar">
                <ul className="mcl-nav-list">
                    <li className={`mcl-nav-item ${location.pathname.startsWith("/category/game-account") ? "mcl-nav-item--active" : ""}`}>
                        <NavLink to="/category/game-account" className="mcl-nav-link">
                            <FaGamepad /> Tài Khoản Game
                        </NavLink>
                    </li>
                    <li className={`mcl-nav-item ${location.pathname.startsWith("/category/top-up") ? "mcl-nav-item--active" : ""}`}>
                        <NavLink to="/category/top-up" className="mcl-nav-link">
                            <GiCardboardBoxClosed /> Nạp Game Mobile
                        </NavLink>
                    </li>
                    <li className={`mcl-nav-item ${location.pathname.startsWith("/category/utility-account") ? "mcl-nav-item--active" : ""}`}>
                        <NavLink to="/category/utility-account" className="mcl-nav-link">
                            <RiNetflixFill /> Tài Khoản Tiện Ích
                        </NavLink>
                    </li>
                    <li className={`mcl-nav-item ${location.pathname.startsWith("/category/gift-card") ? "mcl-nav-item--active" : ""}`}>
                        <NavLink to="/category/gift-card" className="mcl-nav-link">
                            <IoIosGift /> Gift Card
                        </NavLink>
                    </li>

                </ul>
            </aside>

            <main className="mcl-content">
                {children}
            </main>
        </div>
    );
};

export default CategoryLayout;
